import React from "react";

/**
 * Bouncing dots loader component
 * Replaces Mantine Loader with a custom Tailwind-based loader
 * 
 * @param {Object} props
 * @param {string} props.color - Color class for the dots (default: 'bg-primary-blue')
 * @param {string} props.size - Size variant: 'xs', 'sm', 'md', 'lg' (default: 'md')
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 */
export default function BouncingDotsLoader({ 
  color = "bg-primary-blue", 
  size = "md",
  className = "",
  style = {}
}) {
  // Size mapping
  const sizeMap = {
    xs: "w-2 h-2",
    sm: "w-2.5 h-2.5",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  const dotSize = sizeMap[size] || sizeMap.md;
  const gapSize = size === "xs" ? "gap-1.5" : size === "sm" ? "gap-2" : "gap-2";

  return (
    <div 
      className={`flex items-center justify-center ${className}`}
      style={style}
    >
      <div className={`flex ${gapSize}`}>
        <div 
          className={`${dotSize} ${color} rounded-full animate-bounce`} 
          style={{ animationDelay: '0ms' }}
        ></div>
        <div 
          className={`${dotSize} ${color} rounded-full animate-bounce`} 
          style={{ animationDelay: '150ms' }}
        ></div>
        <div 
          className={`${dotSize} ${color} rounded-full animate-bounce`} 
          style={{ animationDelay: '300ms' }}
        ></div>
      </div>
    </div>
  );
}






